import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Typography,
  VertButton,
  VertContainer,
  VertModal,
  VertSelect,
} from '@vertem-core/vertice-ds';
import { Col, Row } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { Form } from '@vertem-core/vertice-ds';
import {
  loadRedemptionSubCategories,
  resetSubCategories,
  updateCategories,
} from 'redux/Reducers/Spot/spotAproveRedemption';

const ModalCategories = ({ product = null, visible, setVisible }) => {

  const [form] = Form.useForm();
  const { redemptionId, id } = product || {};

  const {
    dataCategories,
    dataSubCategories,
    loadingCategories,
    loadingSubCategories,
    loadingSubmitCategory,
  } = useSelector(({ SpotAproveRedemption }) => SpotAproveRedemption);
  const dispatch = useDispatch();

  const dataCategoriesOptions = dataCategories.map((category) => ({
    value: category.id,
    label: category.name,
  }));

  const dataSubCategoriesOptions = dataSubCategories.map((subCategory) => ({
    value: subCategory.id,
    label: subCategory.name,
  }));

  useEffect(() => {
    if (product?.categoryId) {
      form.setFieldsValue({
        category: product?.categoryId,
      });
      dispatch(loadRedemptionSubCategories({ id: product?.categoryId }));
    }
  }, [product?.categoryId]);

  useEffect(() => {
    if (product?.subCategoryId) {
      form.setFieldsValue({
        subCategory: {
          value: product?.subCategoryId,
          label: dataSubCategories.find(
            (subCategory) => subCategory.id === product?.subCategoryId,
          )?.name,
        },
      });
    }
  }, [product?.subCategoryId]);

  const handleChangeCategories = (value) => {
    form.setFieldsValue({ subCategory: '' });
    form.resetFields(['subCategory']);
    dispatch(resetSubCategories());
    dispatch(loadRedemptionSubCategories({ id: value }));
  };

  return (
    <VertModal
      title='Categorias de Produto'
      destroyOnClose

      open={visible}
      onCancel={() => {
        setVisible(false);
        form.resetFields();
      }}
      onOk={() => {}}
      footer={
        <Row justify='space-between'>
          <Col xs={10} sm={10} md={10} lg={10} xl={10} xxl={10}>
            <VertButton
              className='button-view-redemption'
              onClick={() => {
                setVisible(false);
              }}
              loading={loadingSubmitCategory}

              style={{
                border: '1px solid #D9D9D9',
              }}
            >
              CANCELAR
            </VertButton>
          </Col>

          <Col xs={10} sm={10} md={10} lg={10} xl={10} xxl={10}>
            <VertButton
              type='highlight'
              className='button-view-redemption'
              htmlType='submit'
              form='vert-modal-categorie-spot__form'
              loading={loadingSubmitCategory}
            >
              SIM
            </VertButton>
          </Col>
        </Row>
      }
    >
      <VertContainer>
        <Row>
          <Col
            span={24}
            style={{
              marginBottom: '10px',
              display: 'flex',
              justifyContent: 'flex-start',
              flexDirection: 'column',
            }}
          >
            <Typography.Text strong>Nome do Produto:</Typography.Text>
            <Typography.Text>{product?.name}</Typography.Text>
          </Col>
        </Row>
        <Form
          id='vert-modal-categorie-spot__form'
          onFinish={(values) => {
            const data = {
              product: product.id,
              categoryName: dataCategories.find((category) => category.id === values.category).name,
              subCategoryName: dataSubCategories.find(
                (subCategory) => subCategory.id === values.subCategory,
              ).name,
              categoryId: values.category,
              subCategoryId: values.subCategory,
              RedemptionId: redemptionId,
              ProductId: id,
            };

            dispatch(updateCategories(data));
            setVisible(false);
          }}
          layout='vertical'
          form={form}
        >
          <Form.Item
            name='category'
            label='Categoria'
            rules={[
              {
                required: true,
                message: 'Selecione uma categoria',
              },
            ]}
          >
            <VertSelect
              options={dataCategoriesOptions}
              disabled={loadingCategories}
              onChange={handleChangeCategories}
              notFoundContent='Nenhuma categoria encontrada'
            />
          </Form.Item>
          <Form.Item
            name='subCategory'
            label='Subcategoria'
            rules={[
              {
                required: true,
                message: 'Selecione uma subcategoria',
              },
            ]}
          >
            <VertSelect
              options={dataSubCategoriesOptions}
              disabled={loadingSubCategories}
              notFoundContent='Nenhuma subcategoria encontrada'
            />
          </Form.Item>
        </Form>
      </VertContainer>
    </VertModal>
  );
};

export default ModalCategories;
